document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("[data-mobile-menu]");

  if (menuButton && menu) {
    menuButton.addEventListener("click", () => {
      const isOpen = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", String(!isOpen));
      menu.classList.toggle("is-open", !isOpen);
    });

    menu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        menu.classList.remove("is-open");
        menuButton.setAttribute("aria-expanded", "false");
      });
    });
  }

  // Shopify can store pasted HTML as escaped text when it is pasted into the visual editor.
  // Convert only descriptions that clearly contain literal HTML tags, leaving normal rich text untouched.
  document.querySelectorAll("[data-smart-description]").forEach((description) => {
    const text = description.textContent.trim();
    if (/<\/?(h[1-6]|p|ul|ol|li|strong|em|hr|br)\b/i.test(text)) {
      description.innerHTML = text;
    }
  });

  // Product image gallery for stores that upload multiple stock/actual-unit photos.
  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector("[data-gallery-main] img");
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const nextSrc = thumb.dataset.fullImage;
        if (!nextSrc) return;
        mainImage.src = nextSrc;
        mainImage.srcset = "";
        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  });

  document.querySelectorAll("[data-product-filter]").forEach((filterRoot) => {
    const cards = Array.from(filterRoot.querySelectorAll("[data-product-card]"));
    const brandButtons = Array.from(filterRoot.querySelectorAll("[data-brand-filter]"));
    const sizeButtons = Array.from(filterRoot.querySelectorAll("[data-size-filter]"));
    const technologyButtons = Array.from(filterRoot.querySelectorAll("[data-technology-filter]"));
    const input = filterRoot.querySelector("[data-product-search]");
    const result = filterRoot.querySelector("[data-filter-result]");
    const empty = filterRoot.querySelector("[data-filter-empty]");
    const clear = filterRoot.querySelector("[data-filter-clear]");
    let brand = "all";
    let size = "all";
    let technology = "all";

    const setActive = (buttons, active, attribute) => {
      buttons.forEach((button) => {
        const selected = button.getAttribute(attribute) === active;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-pressed", String(selected));
      });
    };

    const apply = () => {
      const query = (input?.value || "").trim().toLowerCase();
      let count = 0;

      cards.forEach((card) => {
        const cardBrand = (card.dataset.productBrand || "").toLowerCase();
        const cardSize = (card.dataset.productSize || "").replace(/[^0-9.]/g, "");
        const cardTechnology = (card.dataset.productTechnology || "").toLowerCase();
        const cardText = card.textContent.toLowerCase();
        const numericSize = Number(cardSize);
        const brandMatch = brand === "all" || cardBrand === brand;
        const sizeMatch =
          size === "all" ||
          cardSize === size ||
          (size === "85plus" && numericSize >= 85 && numericSize < 98);
        const technologyMatch = technology === "all" || cardTechnology === technology;
        const queryMatch = !query || cardText.includes(query);
        const visible = brandMatch && sizeMatch && technologyMatch && queryMatch;
        card.hidden = !visible;
        if (visible) count += 1;
      });

      if (result) result.textContent = `${count} TV${count === 1 ? "" : "s"}`;
      if (empty) empty.hidden = count !== 0;
    };

    brandButtons.forEach((button) => {
      button.addEventListener("click", () => {
        brand = button.dataset.brandFilter || "all";
        setActive(brandButtons, brand, "data-brand-filter");
        apply();
      });
    });

    sizeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        size = button.dataset.sizeFilter || "all";
        setActive(sizeButtons, size, "data-size-filter");
        apply();
      });
    });

    technologyButtons.forEach((button) => {
      button.addEventListener("click", () => {
        technology = button.dataset.technologyFilter || "all";
        setActive(technologyButtons, technology, "data-technology-filter");
        apply();
      });
    });

    input?.addEventListener("input", apply);
    clear?.addEventListener("click", () => {
      brand = "all";
      size = "all";
      technology = "all";
      if (input) input.value = "";
      setActive(brandButtons, brand, "data-brand-filter");
      setActive(sizeButtons, size, "data-size-filter");
      setActive(technologyButtons, technology, "data-technology-filter");
      const url = new URL(window.location.href);
      url.searchParams.delete("size");
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
      apply();
    });

    filterRoot.peraApplySize = (value) => {
      brand = "all";
      size = value;
      technology = "all";
      if (input) input.value = "";
      setActive(brandButtons, brand, "data-brand-filter");
      setActive(sizeButtons, size, "data-size-filter");
      setActive(technologyButtons, technology, "data-technology-filter");
      apply();
    };

    const params = new URLSearchParams(window.location.search);
    const requestedSize = params.get("size");
    if (requestedSize && sizeButtons.some((button) => button.dataset.sizeFilter === requestedSize)) {
      filterRoot.peraApplySize(requestedSize);
    } else {
      apply();
    }
  });

  // Pera app-style page views: top navigation opens a dedicated screen instead of scrolling the homepage.
  const activeView = document.documentElement.getAttribute("data-pera-view") || "home";
  document.body.setAttribute("data-active-view", activeView);
  document.querySelectorAll("[data-pera-view-section]").forEach((section) => {
    const isActive = section.getAttribute("data-pera-view-section") === activeView;
    section.hidden = !isActive;
    section.setAttribute("aria-hidden", String(!isActive));
  });

  document.querySelectorAll("[data-app-route]").forEach((link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      const targetView = url.searchParams.get("view");
      if (targetView && targetView === activeView && window.location.pathname === "/") {
        link.classList.add("is-current");
        link.setAttribute("aria-current", "page");
      }
    } catch (e) {}
  });

  if (window.location.pathname === "/" && activeView !== "home") {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }

});

// === Pera AI TV Advisor v1 ===
// Immediate, privacy-friendly advisor using live Shopify catalog data rendered by Liquid.
// A secure server-side AI endpoint can optionally be connected later; private API keys must never live in theme code.
document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-pera-ai]");
  if (!root) return;

  const launcher = root.querySelector("[data-pera-ai-toggle]");
  const panel = root.querySelector("[data-pera-ai-panel]");
  const close = root.querySelector("[data-pera-ai-close]");
  const messages = root.querySelector("[data-pera-ai-messages]");
  const form = root.querySelector("[data-pera-ai-form]");
  const input = root.querySelector("[data-pera-ai-input]");
  const catalogNode = root.querySelector("[data-pera-ai-products]");
  const configuredEndpoint = (root.dataset.aiEndpoint || "").trim();

  let products = [];
  try {
    products = JSON.parse(catalogNode?.textContent || "[]").filter((product) => product && product.available !== false);
  } catch (e) {
    products = [];
  }

  const escapeHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const money = (value) => {
    const amount = Number(value || 0);
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(amount);
  };

  const numeric = (value) => {
    const match = String(value || "").match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  };

  const haystack = (product) => [
    product.title, product.vendor, product.tags, product.technology, product.refreshRate,
    product.hdr, product.smartPlatform, product.model, product.size
  ].filter(Boolean).join(" ").toLowerCase();

  const techRank = (product) => {
    const text = haystack(product);
    if (text.includes("oled")) return 5;
    if (text.includes("mini led") || text.includes("mini-led") || text.includes("qd-mini")) return 4.5;
    if (text.includes("qled") || text.includes("quantum")) return 3.5;
    if (text.includes("crystal") || text.includes("uhd")) return 2;
    return 1;
  };

  const refresh = (product) => numeric(product.refreshRate || haystack(product));
  const size = (product) => numeric(product.size || product.title);

  const cardMarkup = (product, reason = "") => `
    <a class="pera-ai__product" href="${escapeHtml(product.url || `/products/${product.handle}`)}">
      <span class="pera-ai__product-main">
        <strong>${escapeHtml(product.title)}</strong>
        ${reason ? `<small>${escapeHtml(reason)}</small>` : ""}
      </span>
      <span class="pera-ai__product-price">${money(product.price)}</span>
    </a>`;

  const addMessage = (role, html) => {
    if (!messages) return;
    const node = document.createElement("div");
    node.className = `pera-ai__message pera-ai__message--${role}`;
    node.innerHTML = html;
    messages.appendChild(node);
    messages.scrollTop = messages.scrollHeight;
  };

  const productResponse = (intro, items, reasonFn) => {
    if (!items.length) {
      return `<p>I couldn’t find an in-stock match in the current online listings. Try a different budget or <a href="/collections/all">browse all TVs</a>. You can also call <a href="tel:3463870151">346-387-0151</a> to confirm newly arrived inventory.</p>`;
    }
    return `<p>${escapeHtml(intro)}</p><div class="pera-ai__products">${items.slice(0, 4).map((p) => cardMarkup(p, reasonFn ? reasonFn(p) : "")).join("")}</div>`;
  };

  const localAdvisor = (rawQuestion) => {
    const question = String(rawQuestion || "").trim();
    const q = question.toLowerCase();
    const hiddenHandles = new Set(["75-samsung-qled-4k-smart-tv", "samsung-qled-q7f-75-4k-smart-tv", "86-lg-uhd-4k-smart-tv"]);
    const available = products.filter((p) => p.available !== false && !hiddenHandles.has(String(p.handle || "")));

    if (!available.length) {
      return `<p>I’m having trouble reading the live catalog right now. Please <a href="/collections/all">browse Shop TVs</a> or call <a href="tel:3463870151">346-387-0151</a>.</p>`;
    }

    // Store-service questions.
    if (/financ|payment|lease|acima|snap|progressive/.test(q)) {
      return `<p>Pera Outlet offers lease-to-own options through <strong>Acima, Snap Finance and Progressive Leasing</strong>. Each provider makes its own approval decision. <a href="/?view=financing">Open Financing</a> to apply.</p>`;
    }
    if (/warrant|guarantee|return/.test(q)) {
      return `<p>Unless a product listing says otherwise, TVs include a <strong>30-day limited store warranty</strong>. Every TV is Brand New Open Box or Brand New Overstock, professionally inspected and tested before sale. Included accessories can vary by unit. For returns or warranty eligibility, please confirm the specific product terms or call <a href="tel:3463870151">346-387-0151</a>.</p>`;
    }
    if (/deliver|delivery/.test(q)) {
      return `<p>Local delivery may be available for an additional charge depending on TV size and destination. Call <a href="tel:3463870151">346-387-0151</a> for a delivery quote.</p>`;
    }
    if (/address|location|where are you|hours|open today|pickup/.test(q)) {
      return `<p>Pera Outlet is at <strong>8950 Westpark Dr, Suite 212, Houston, TX 77063</strong>, open daily <strong>11:00 AM–6:00 PM</strong>. <a href="/?view=visit">Get directions</a>.</p>`;
    }
    if (/open box|open-box|used|condition/.test(q)) {
      return `<p>Pera Outlet does <strong>not sell used TVs or customer-returned TVs</strong>. Inventory is Brand New Open Box or Brand New Overstock. Every TV is professionally inspected and tested before sale, with a final check at pickup.</p>`;
    }

    // Explicit budget: $, USD, budget, under/below/less than.
    const budgetContext = /\$|usd|budget|under|below|less than|up to|spend|afford/.test(q);
    const budgetMatch = q.match(/(?:\$\s*|usd\s*|budget\s*(?:is|of)?\s*|under\s*|below\s*|less than\s*|up to\s*)(\d{2,5})/i)
      || (budgetContext ? q.match(/(\d{2,5})/) : null);
    if (budgetMatch) {
      const budget = Number(budgetMatch[1]);
      const matches = available
        .filter((p) => Number(p.price) <= budget)
        .sort((a, b) => (techRank(b) - techRank(a)) || (size(b) - size(a)) || (Number(b.price) - Number(a.price)));
      return productResponse(`Here are my best current options at ${money(budget)} or less:`, matches, (p) => `${size(p) ? `${size(p)}\" • ` : ""}${p.technology || "4K Smart TV"}`);
    }

    // Requested screen size.
    const sizeMatch = q.match(/(\d{2,3})\s*(?:inch|inches|\")/i);
    if (sizeMatch) {
      const requested = Number(sizeMatch[1]);
      const matches = available
        .filter((p) => Math.abs(size(p) - requested) < 0.5)
        .sort((a, b) => techRank(b) - techRank(a) || Number(a.price) - Number(b.price));
      return productResponse(`These are the current ${requested}-inch choices I found:`, matches, (p) => `${p.technology || "4K"} • ${refresh(p) ? `${refresh(p)}Hz` : "Smart TV"}`);
    }

    // Brand request.
    const brand = ["sony", "samsung", "lg", "tcl", "vizio", "hisense", "philips", "element"].find((name) => q.includes(name));
    if (brand) {
      const matches = available
        .filter((p) => String(p.vendor || "").toLowerCase() === brand || haystack(p).includes(brand))
        .sort((a, b) => techRank(b) - techRank(a) || size(b) - size(a));
      return productResponse(`Here are the strongest ${brand.toUpperCase()} options currently listed:`, matches, (p) => `${size(p) ? `${size(p)}\" • ` : ""}${p.technology || "4K Smart TV"}`);
    }

    if (/ps5|playstation|xbox|gaming|game/.test(q)) {
      const scored = available.map((p) => {
        const text = haystack(p);
        let score = 0;
        const hz = refresh(p);
        if (hz >= 144) score += 8; else if (hz >= 120) score += 7; else if (hz >= 100) score += 4;
        if (text.includes("hdmi 2.1")) score += 6;
        if (text.includes("vrr")) score += 4;
        if (text.includes("allm")) score += 2;
        score += techRank(p) * 1.5;
        return { p, score };
      }).sort((a, b) => b.score - a.score || Number(a.p.price) - Number(b.p.price));
      return productResponse("For PS5 / Xbox, I’d prioritize 120Hz+, HDMI 2.1 and VRR when available. My current picks are:", scored.map((x) => x.p), (p) => `${refresh(p) || 60}Hz • ${p.technology || "4K"}${haystack(p).includes("hdmi 2.1") ? " • HDMI 2.1" : ""}`);
    }

    if (/movie|movies|cinema|film|home theater|dark room/.test(q)) {
      const matches = available.slice().sort((a, b) => {
        const aText = haystack(a), bText = haystack(b);
        const cinema = (p, text) => techRank(p) * 5 + (text.includes("dolby vision") ? 5 : 0) + size(p) / 20;
        return cinema(b,bText) - cinema(a,aText);
      });
      return productResponse("For movies, I’d favor OLED or Mini LED, strong HDR and a larger screen. These are my current picks:", matches, (p) => `${p.technology || "4K"}${String(p.hdr || "").toLowerCase().includes("dolby") ? " • Dolby Vision" : ""} • ${size(p) || "Large"}\"`);
    }

    if (/sport|football|soccer|basketball|nba|nfl|fast motion/.test(q)) {
      const matches = available.slice().sort((a, b) => (refresh(b) - refresh(a)) || techRank(b) - techRank(a) || size(b) - size(a));
      return productResponse("For sports, smooth motion matters most. I’d start with the highest-refresh-rate TVs in stock:", matches, (p) => `${refresh(p) || 60}Hz • ${size(p) || ""}\" • ${p.technology || "4K"}`);
    }

    if (/bright room|sunlight|sunny|daylight|window|glare/.test(q)) {
      const matches = available.slice().sort((a, b) => {
        const brightScore = (p) => {
          const text = haystack(p);
          let score = 0;
          if (text.includes("mini led") || text.includes("mini-led") || text.includes("qd-mini")) score += 10;
          if (text.includes("qled") || text.includes("quantum")) score += 7;
          if (text.includes("outdoor")) score += 12;
          return score + techRank(p);
        };
        return brightScore(b) - brightScore(a) || size(b) - size(a);
      });
      return productResponse("For a bright room, Mini LED and QLED are usually strong choices because they can stay punchy in ambient light. Current picks:", matches, (p) => `${p.technology || "4K"} • ${size(p) || ""}\"`);
    }

    if (/biggest|largest|huge|big screen/.test(q)) {
      const matches = available.slice().sort((a, b) => size(b) - size(a) || techRank(b) - techRank(a));
      return productResponse("These are the biggest TVs currently listed:", matches, (p) => `${size(p) || ""}\" • ${p.technology || "4K Smart TV"}`);
    }

    if (/cheapest|lowest price|least expensive|best deal|deal/.test(q)) {
      const matches = available.slice().sort((a, b) => Number(a.price) - Number(b.price));
      return productResponse("These are the lowest-priced TVs currently listed:", matches, (p) => `${size(p) || ""}\" • ${p.technology || "4K Smart TV"}`);
    }

    return `<p>I can help with <strong>budget, PS5/Xbox, movies, sports, bright rooms, brand or screen size</strong>. Try “What can I buy for $500?” or “What’s the best TV for PS5?”</p><p>You can also <a href="/collections/all">browse all current TVs</a>.</p>`;
  };

  const remoteAdvisor = async (question) => {
    if (!configuredEndpoint) return null;
    try {
      const response = await fetch(configuredEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          message: question,
          products: products.map(({ id, title, handle, url, vendor, available, price, compareAt, tags, size, technology, refreshRate, hdr, smartPlatform, model }) => ({
            id, title, handle, url, vendor, available, price, compareAt, tags, size, technology, refreshRate, hdr, smartPlatform, model
          }))
        })
      });
      if (!response.ok) return null;
      const data = await response.json();
      if (typeof data?.html === "string") return data.html;
      if (typeof data?.answer === "string") return `<p>${escapeHtml(data.answer)}</p>`;
      return null;
    } catch (e) {
      return null;
    }
  };

  const ask = async (question) => {
    const clean = String(question || "").trim();
    if (!clean) return;
    addMessage("user", `<p>${escapeHtml(clean)}</p>`);
    if (input) input.value = "";
    addMessage("assistant", `<p class="pera-ai__thinking">Checking current inventory…</p>`);
    const thinking = messages?.lastElementChild;
    const remote = await remoteAdvisor(clean);
    const answer = remote || localAdvisor(clean);
    if (thinking) thinking.innerHTML = answer;
    messages?.scrollTo({ top: messages.scrollHeight, behavior: "smooth" });
  };

  const openPanel = () => {
    if (!panel || !launcher) return;
    panel.hidden = false;
    launcher.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => root.classList.add("is-open"));
    setTimeout(() => input?.focus(), 80);
  };

  const closePanel = () => {
    if (!panel || !launcher) return;
    root.classList.remove("is-open");
    launcher.setAttribute("aria-expanded", "false");
    setTimeout(() => { panel.hidden = true; }, 180);
  };

  launcher?.addEventListener("click", () => root.classList.contains("is-open") ? closePanel() : openPanel());
  close?.addEventListener("click", closePanel);
  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    ask(input?.value || "");
  });
  root.querySelectorAll("[data-pera-ai-question]").forEach((button) => {
    button.addEventListener("click", () => ask(button.dataset.peraAiQuestion || ""));
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && root.classList.contains("is-open")) closePanel();
  });
});

// FAQ search + bridge to Pera AI.
document.addEventListener("DOMContentLoaded", () => {
  const search = document.querySelector("[data-pera-faq-search]");
  const items = Array.from(document.querySelectorAll("[data-pera-faq-item]"));
  const count = document.querySelector("[data-pera-faq-count]");
  const empty = document.querySelector("[data-pera-faq-empty]");
  if (search && items.length) {
    const filterFaq = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const match = !query || item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = `${visible} answer${visible === 1 ? "" : "s"} available`;
      if (empty) empty.hidden = visible !== 0;
    };
    search.addEventListener("input", filterFaq);
  }

  document.querySelectorAll("[data-pera-open-ai]").forEach((button) => {
    button.addEventListener("click", () => {
      const ai = document.querySelector("[data-pera-ai]");
      const launcher = ai?.querySelector("[data-pera-ai-toggle]");
      if (launcher && !ai.classList.contains("is-open")) launcher.click();
      const aiInput = ai?.querySelector("[data-pera-ai-input]");
      const query = document.querySelector("[data-pera-faq-search]")?.value.trim();
      if (aiInput && query) aiInput.value = query;
      setTimeout(() => aiInput?.focus(), 80);
    });
  });
});
